import { mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { useAppHostCommonStyles } from '../styles';
export const AppHostStyledContainer = ({ children }) => {
    const styles = useAppHostCommonStyles();
    return (React.createElement("div", { className: mergeClasses(styles.displayFlex, styles.flexGrow1, styles.heightInherit, styles.mediaMaxWidthOverflow) },
        React.createElement("div", { className: mergeClasses(styles.displayFlex, styles.flexGrow1, styles.flexColumn) }, children)));
};
//# sourceMappingURL=AppHostStyledContainer.js.map